import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";
import { IJobNature } from "../../../feature-module/pages/masters/jobNatures";

interface IJobNaturesState {
  data: IJobNature[];
  loading: boolean;
  error: string | null;
  total: number;
  page: number;
  limit: number;
}

const initialState: IJobNaturesState = {
  data: [],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  limit: 10,
};

export const getAllJobNatures = createAsyncThunk(
  'get/masterNature',
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.MASTERS.FIND_ALL_NATURES,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const jobNaturesSlice = createSlice({
  name: 'jobNatures',
  initialState,
  reducers: {
    resetJobNatures: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllJobNatures.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllJobNatures.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data || [];
        state.total = action.payload.total || 0;
        state.page = action.payload.page || 1;
        state.limit = action.payload.limit || 10;
      })
      .addCase(getAllJobNatures.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || 'Failed to fetch job natures';
      });
  },
});

export const { resetJobNatures } = jobNaturesSlice.actions;
export default jobNaturesSlice.reducer;
